module.exports = __webpack_public_path__ + "ab7b6e3aa300bd05bd5bb0ab30aa4647.glb";